import { handleResponseError } from 'helpers/utils'
import { API } from './endpoint'
import { GetFactoryIncomeChartResponse, GetFactoryOverviewCancelResponse, GetFactoryOverviewCompleteResponse, GetFactoryOverviewInprogressResponse, GetFactoryOverviewOpenResponse, GetFactoryOverviewResponse, GetFactoryTopSaleReportResponse, InputGetFactoryIncomeChart, InputGetFactoryOverview } from './interface'
import httpClient from '../axios/interceptors'
import { AxiosResponse } from 'axios'

export const getReportOverview = async (
  input: InputGetFactoryOverview
): Promise<GetFactoryOverviewResponse> => {
  const data: AxiosResponse<GetFactoryOverviewResponse> = await httpClient
    .post(API.getReportOverview, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const getReportOverviewCancel = async (
  input: InputGetFactoryOverview
): Promise<GetFactoryOverviewCancelResponse> => {
  const data: AxiosResponse<GetFactoryOverviewCancelResponse> = await httpClient
    .post(API.getReportOverviewCancel, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const getReportOverviewInprogress = async (
  input: InputGetFactoryOverview
): Promise<GetFactoryOverviewInprogressResponse> => {
  const data: AxiosResponse<GetFactoryOverviewInprogressResponse> = await httpClient
    .post(API.getReportOverviewInprogress, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const getReportOverviewComplete = async (
  input: InputGetFactoryOverview
): Promise<GetFactoryOverviewCompleteResponse> => {
  const data: AxiosResponse<GetFactoryOverviewCompleteResponse> = await httpClient
    .post(API.getReportOverviewComplete, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const getReportOverviewOpen = async (
  input: InputGetFactoryOverview
): Promise<GetFactoryOverviewOpenResponse> => {
  const data: AxiosResponse<GetFactoryOverviewOpenResponse> = await httpClient
    .post(API.getReportOverviewOpen, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const getReportTopSale = async (
  input: InputGetFactoryOverview
): Promise<GetFactoryTopSaleReportResponse> => {
  const data: AxiosResponse<GetFactoryTopSaleReportResponse> = await httpClient
    .post(API.getReportTopSale, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const getIncomeChart = async (
  input: InputGetFactoryIncomeChart
): Promise<GetFactoryIncomeChartResponse> => {
  const data: AxiosResponse<GetFactoryIncomeChartResponse> = await httpClient
    .post(API.getIncomeChart, input)
    .catch((error) => handleResponseError(error))
  return data.data
}